import { Rest } from './rest'

const headers = ({ token }) => {
  return { Authorization: `Bearer ${token}` }
}
const Notification = new Rest(process.env.REACT_APP_NOTIFICATION, headers)

export default Notification
